//系统管理
import role from '@/view/system/role'
import menus from '@/view/system/menus'

//用户管理
import cmUser from '@/view/system/cmUser'
import institution from '@/view/system/institution'

//日志管理
import errorLog from '@/view/system/errorLog'
import cmPackage from '@/view/system/cmPackage'


export default [{
		path: 'system/role',
		name: 'role',
		component: role,
	}, {
		path: 'system/menus',
		name: 'menus',
		component: menus,
	}, 
	{
		path: 'user/cmUser',
		name: 'cmUser',
		component: cmUser,
	}, {
		path: 'user/front',
		name: 'institution',
		component: institution,
	}, {
		path: 'user/institution',
		name: 'institution',
		component: institution,
	},
	//日志管理
	{
		path: 'log/errorLog',
		name: 'errorLog',
		component: errorLog,
	},
	{
		path: 'sys/package',
		name: 'cmPackage',
		component: cmPackage,
	}
]



// WEBPACK FOOTER //
// ./src/router/system.js